import { TextProps, Text } from '@cad-arc';
import { escapeRegExp } from 'lodash';
import React from 'react';
import { Mark } from './mark';

type HighlightedTextProps = {
    children: string;
    matchPattern: string;
} & TextProps;

export const HighlightedText = (props: HighlightedTextProps): JSX.Element => {
    const { children, matchPattern, ...other } = props;

    if (props.matchPattern === '') {
        return <Text {...other}>{props.children}</Text>;
    }

    const queryRegex = new RegExp(`(${escapeRegExp(props.matchPattern)})`, 'gi');
    const allText = props.children.split(queryRegex);

    return (
        <Text {...other}>
            {allText.map((v, i) =>
                queryRegex.test(v) ? (
                    <Mark
                        style={{
                            bg: 'selected.emphasis',
                            color: 'selected.emphasisContent',
                            paddingInline: 'px',
                        }}
                        key={i}
                    >
                        {v}
                    </Mark>
                ) : (
                    <React.Fragment key={i}>{v}</React.Fragment>
                )
            )}
        </Text>
    );
};
